(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pps-footer-discount')) {
    customElements.define('pps-footer-discount', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.pps-footer__copy-code');
        const code = this.querySelector('.pps-footer__discount-code');
        const status = this.querySelector('.pps-footer__copy-status');
        if (!button || !code || !status) return;

        button.hidden = false;
        button.onclick = async () => {
          if (button.disabled) return;
          button.disabled = true;
          status.textContent = '';
          let copied = false;

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code.value);
              copied = true;
            }
          } catch (error) {}

          if (!copied) {
            code.focus();
            code.select();
            code.setSelectionRange(0, code.value.length);
            try {
              copied = document.execCommand('copy');
            } catch (error) {}
          }

          status.textContent = copied
            ? button.dataset.copiedLabel
            : button.dataset.copyError;
          button.disabled = false;
          if (copied) button.focus({ preventScroll: true });
        };
      }

      disconnectedCallback() {
        const button = this.querySelector('.pps-footer__copy-code');
        if (button) button.onclick = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-gang-sheet"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const galleries = root.matches?.('[data-pps-gallery]') ? [root] : root.querySelectorAll('[data-pps-gallery]');
      galleries.forEach((gallery) => {
        if (gallery.dataset.ppsInitialized) return;
        gallery.dataset.ppsInitialized = 'true';
        gallery.querySelectorAll('.pps-pdp__app .gs--button').forEach((control) => {
          if (control.tagName !== 'DIV') return;
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            control.click();
          });
        });
        const image = gallery.querySelector('.pps-pdp__main-image');
        const thumbnails = gallery.querySelector('.pps-pdp__thumbnails');
        if (!image || !thumbnails) return;
        thumbnails.hidden = false;
        thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-url]');
          if (!button || !thumbnails.contains(button)) return;
          const url = new URL(button.dataset.imageUrl, window.location.href);
          image.srcset = [320,480,640,800,1000,1200,1400].map((width) => {
            url.searchParams.set('width', width);
            return `${url.href} ${width}w`;
          }).join(', ');
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          thumbnails.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-pre-cut"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const galleries = root.matches?.('[data-pps-gallery]') ? [root] : root.querySelectorAll('[data-pps-gallery]');
      galleries.forEach((gallery) => {
        if (gallery.dataset.ppsInitialized) return;
        gallery.dataset.ppsInitialized = 'true';
        gallery.querySelectorAll('.pps-precut__app .gs--button').forEach((control) => {
          if (control.tagName !== 'DIV') return;
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            control.click();
          });
        });
        const image = gallery.querySelector('.pps-precut__main-image');
        const thumbnails = gallery.querySelector('.pps-precut__thumbnails');
        if (!image || !thumbnails) return;
        thumbnails.hidden = false;
        thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-url]');
          if (!button || !thumbnails.contains(button)) return;
          const url = new URL(button.dataset.imageUrl, window.location.href);
          image.srcset = [320,480,640,800,1000,1200,1400].map((width) => {
            url.searchParams.set('width', width);
            return `${url.href} ${width}w`;
          }).join(', ');
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          thumbnails.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-video-reels"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;

    const cleanup = [];
    const on = (target, event, handler) => {
      target.addEventListener(event, handler);
      cleanup.push(() => target.removeEventListener(event, handler));
    };

    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;

    const autoAllowed = () =>
      !motion.matches &&
      !connection?.saveData &&
      !/^(slow-2g|2g)$/.test(connection?.effectiveType || '') &&
      !window.Shopify?.designMode;

    const collection = root.querySelector('.pps-reels-track');
    const cards = [...root.querySelectorAll('.pps-reel')];

    if (root.dataset.shuffle === 'true' && !window.Shopify?.designMode && cards.length > 1) {
      for (let index = cards.length - 1; index > 0; index--) {
        const other = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[other]] = [cards[other], cards[index]];
      }

      const order = () => cards.map(card => card.dataset.clipId).join(',');

      try {
        const key = 'pps-reels-order:' + collection.id;
        if (sessionStorage.getItem(key) === order()) cards.push(cards.shift());
        sessionStorage.setItem(key, order());
      } catch {
        /* Shuffling still works when browser storage is unavailable. */
      }

      cards.forEach((card, index) => {
        collection.appendChild(card);
        const counter = card.querySelector('.pps-reel-counter');
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      });

      collection.scrollLeft = 0;
    }

    const videos = [...root.querySelectorAll('video')];
    const states = new Map();
    const desktop = window.matchMedia('(min-width: 750px)');
    let activeVideo = null;
    let userPaused = false;

    const safePlay = video => {
      const result = video.play();
      if (result?.catch) result.catch(() => {});
    };

    const activate = (video, manual = false) => {
      videos.forEach(other => {
        if (other !== video) {
          other.pause();
          other.muted = true;
        }
      });

      activeVideo = video;

      if (manual) {
        userPaused = false;
        states.get(video).manualPlay = true;
      }

      if (video.ended) video.currentTime = 0;
      safePlay(video);
    };

    videos.forEach(video => {
      const card = video.closest('.pps-reel');
      const play = card.querySelector('.pps-reel-play');
      const sound = card.querySelector('.pps-reel-sound');

      if (card.dataset?.silent === 'true') sound.hidden = true;

      const poster = card.querySelector('.pps-reel-poster');
      if (poster) video.poster = poster.content.textContent.trim();

      video.controls = false;
      video.setAttribute('playsinline', '');
      video.muted = true;
      video.loop = !desktop.matches;
      card.querySelector('.pps-reel-controls').hidden = false;

      const state = {
        visible: false,
        manualPause: false,
        manualPlay: false
      };

      states.set(video, state);

      const sync = () => {
        play.setAttribute('aria-label', video.paused ? root.dataset.play : root.dataset.pause);

        play.querySelector('span').innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="display:block">' +
          (video.paused
            ? '<path d="M8 5v14l11-7z"/>'
            : '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>') +
          '</svg>';

        sound.setAttribute('aria-label', video.muted ? root.dataset.soundOn : root.dataset.soundOff);
        sound.setAttribute('aria-pressed', String(!video.muted));
        sound.querySelector('.pps-reel-sound-state').textContent = video.muted ? 'OFF' : 'ON';
      };

      on(play, 'click', () => {
        if (video.paused) {
          state.manualPause = false;
          activate(video, true);
        } else {
          state.manualPause = true;
          state.manualPlay = false;
          userPaused = true;
          video.pause();
        }
      });

      on(sound, 'click', () => {
        if (video.muted) {
          videos.forEach(other => {
            if (other !== video) other.muted = true;
          });
        }

        video.muted = !video.muted;
        sync();
      });

      ['play', 'pause', 'volumechange', 'ended'].forEach(event => on(video, event, sync));

      on(video, 'ended', () => {
        if (
          !desktop.matches ||
          userPaused ||
          document.hidden ||
          !autoAllowed() ||
          activeVideo !== video ||
          root.contains(document.activeElement)
        ) return;

        const index = videos.indexOf(video);

        for (let offset = 1; offset <= videos.length; offset++) {
          const nextVideo = videos[(index + offset) % videos.length];

          if (states.get(nextVideo).visible) {
            nextVideo.currentTime = 0;
            activate(nextVideo);
            break;
          }
        }
      });

      on(video, 'error', () => {
        video.controls = true;
        card.querySelector('.pps-reel-controls').hidden = true;
      });

      sync();
    });

    const resume = () => {
      videos.forEach(video => {
        if (!states.get(video).visible || document.hidden) video.pause();
      });

      if (document.hidden || userPaused) return;

      const candidate =
        activeVideo && states.get(activeVideo).visible
          ? activeVideo
          : videos.find(video => states.get(video).visible);

      if (candidate && (states.get(candidate).manualPlay || autoAllowed())) {
        activate(candidate);
      } else {
        videos.forEach(video => video.pause());
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.get(entry.target);
          state.visible = entry.isIntersecting &&
            entry.intersectionRatio >= (desktop.matches ? .35 : .6);
        });

        resume();
      }, { threshold: [0, .35, .6] });

      videos.forEach(video => observer.observe(video));
      cleanup.push(() => observer.disconnect());
    }

    on(document, 'visibilitychange', resume);
    on(motion, 'change', resume);

    on(desktop, 'change', () => {
      videos.forEach(video => {
        video.loop = !desktop.matches;
      });
      resume();
    });

    if (connection?.addEventListener) on(connection, 'change', resume);

    const track = root.querySelector('.pps-reels-track');
    const nav = root.querySelector('.pps-reels-nav');
    const prev = root.querySelector('[data-reel-prev]');
    const next = root.querySelector('[data-reel-next]');

    const update = () => {
      const overflow = track.scrollWidth - track.clientWidth;
      nav.hidden = overflow <= 8;
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft >= overflow - 5;
    };

    const step = direction => {
      const card = track.querySelector('.pps-reel');
      if (!card) return;

      track.scrollBy({
        left: direction * (
          card.getBoundingClientRect().width +
          parseFloat(getComputedStyle(track).columnGap)
        ),
        behavior: motion.matches ? 'instant' : 'smooth'
      });
    };

    on(prev, 'click', () => step(-1));
    on(next, 'click', () => step(1));
    on(track, 'scroll', update);
    on(window, 'resize', update);

    if ('ResizeObserver' in window) {
      const resize = new ResizeObserver(update);
      resize.observe(track);
      cleanup.push(() => resize.disconnect());
    }

    update();

    instances.set(root, () => {
      cleanup.forEach(fn => fn());
      videos.forEach(video => video.pause());
      instances.delete(root);
    });
  }

  const scan = target => {
    if (target.matches?.('[data-pps-reels]')) init(target);
    target.querySelectorAll('[data-pps-reels]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', event => scan(event.target));

  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-pps-reels]').forEach(root => instances.get(root)?.());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
